import { render, staticRenderFns } from "./CardsActionsComponent.vue?vue&type=template&id=39d55af8"
import script from "./CardsActionsComponent.vue?vue&type=script&lang=js"
export * from "./CardsActionsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports